import { Alert, Button, Spin } from "@arco-design/web-react";

import { useItinerarySidePreview } from "../runtime/useItinerarySidePreview";
import type { ItineraryEditor } from "../types";
import { ItineraryClientDetail } from "./ItineraryClientDetail";

type Props = {
  itineraryId: string;
  savedRevision?: string;
  refreshSequence?: number;
  loadEditor: () => Promise<ItineraryEditor>;
};

/** 在编辑器右栏展示已保存行程，保持编辑画布可操作。 */
export function ItinerarySidePreview({ itineraryId, savedRevision, refreshSequence, loadEditor }: Props) {
  const preview = useItinerarySidePreview(itineraryId, savedRevision, loadEditor, refreshSequence);
  return <section className="itinerary-side-preview" aria-label="侧栏行程预览" aria-busy={preview.isFetching}>
    {preview.isFetching ? <div className="itinerary-customization-state" role="status">
      <Spin size={24} />
      <span>正在加载最新保存的行程…</span>
    </div> : preview.isError ? <Alert
      type="error"
      showIcon
      content="行程预览加载失败，请重试。"
      action={<Button size="small" onClick={() => void preview.refetch()}>重试</Button>}
    /> : preview.data ? <ItineraryClientDetail itinerary={preview.data} idPrefix="itinerary-side-detail" /> : null}
  </section>;
}
